import React from 'react';
import type {
  FrameworkViewProps,
} from '@plerionhq/design-system';
import { withErrorBoundary } from '../../../hoc/withErrorBoundary';

const FrameworkPage = withErrorBoundary(
  React.lazy(() => import('../../../micro-frontends/components/FrameworkPage')),
);

export const FrameworkPageView = (props: FrameworkViewProps) => {
  return <FrameworkPage embeddedView {...props.data} />;
};
